import type { ViewDefinition } from './viewTypes'

export function sealedFields(view: ViewDefinition, data: Record<string, unknown>, binding?: string): string[] {
    const rule = view.sealedWhen
    if (!rule) return []
    const root = rule.binding.replace(/^\$/, '')
    const record = data[root]
    if (!record || typeof record !== 'object') return []
    if (!rule.stamps.some(s => {
        const value = (record as Record<string, unknown>)[s]
        return value !== null && value !== undefined && String(value).trim() !== ''
    })) return []
    const path = (binding ?? '').replace(/^\$/, '')
    if (path === root) return [...rule.fields, ...rule.stamps]
    return path.startsWith(root + '.') ? (rule.children?.[path.slice(root.length + 1)] ?? []) : []
}
